var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-card-title',[_vm._v("Public Reference Materials")]),_c('v-divider'),_c('v-card-text',{staticClass:"mx-auto"},[_c('v-data-table',{attrs:{"headers":_vm.PublicReferenceMaterialsHeaders,"items":_vm.PublicReferenceMaterials}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }